<!-- Inner Banner Start-->
<section class="inner-hero-banner">
  <div class="inner-hero-text">
    <h1 i18n>Page Not Found</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#" i18n>Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">404</li>
      </ol>
    </nav>
  </div>
</section>
<!-- Inner Banner End -->
<!-- Start 404 Content Area -->
<section class="section">
  <div class="error-page-area">
    <div class="container">
      <div class="row">
        <!--404 text image-->
        <div class="col-xl-12">
          <div class="text-center">
            <div class="error-img">
              <img src="assets/images/404.jpg" class="img-fluid" alt="">
            </div>
            <h2 i18n>sorry we can't found anything</h2>
            <div class="d-flex justify-content-center">
              <a href="index.html" class="btn btn-sm theme-btn text-white text-uppercase send-btn" i18n>back to home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End 404 Content Area -->
